import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { PlatformType } from '../types/muni-environment';

interface BondlinkResponse {
  found: {
    link: string;
    id: string;
  };
}

@Injectable()
export class BondLinkService {
  private readonly muniApiHost: string;
  private readonly platform: PlatformType;

  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.platform = config.params.platform as PlatformType;
    this.muniApiHost = config.params.muniApiHost as string;
  }

  public getWebsiteUrl(issuerId: string): Observable<string | Error> {
    return this.http
      .get<BondlinkResponse>(`${this.muniApiHost}/bondlink/${issuerId}`, {
        observe: 'response',
        headers:
          this.platform === 'buyside' ? { Authorization: 'BSP-JWT' } : null,
      })
      .pipe(
        mergeMap((response) => {
          const data = response.status === 200 && response.body;
          return data
            ? of(data.found[0].link)
            : throwError(Error('No website'));
        })
      );
  }
}
